export const name = "ST_X";
export const summary = `Gets the longitude from a point \`GEOGRAPHY\` value.`;
export const reference = `
## ST_X

Gets the longitude from a point \`GEOGRAPHY\` value.

\`\`\`
ST_X(point_geography_expression)
\`\`\`

### Description

Returns the longitude in degrees of the single-point input\`GEOGRAPHY\`.

For any input \`GEOGRAPHY\` that isn't a single point, including an empty \`GEOGRAPHY\`, \`ST_X\` returns an error. Use the \`SAFE.\` prefix to obtain \`NULL\`.


### Return type

\`FLOAT64\`


### Example

The following example uses \`ST_X\` and \`ST_Y\` to extract coordinates from single-point geographies.



\`\`\`
WITH points AS
   (SELECT ST_GEOGPOINT(i, i + 1) AS p FROM UNNEST([0, 5, 12]) AS i)
 SELECT
   p,
   ST_X(p) as longitude,
   ST_Y(p) as latitude
FROM points;

/*--------------+-----------+----------*
 | p | longitude | latitude |
 +--------------+-----------+----------+
 | POINT(0 1) | 0.0 | 1.0 |
 | POINT(5 6) | 5.0 | 6.0 |
 | POINT(12 13) | 12.0 | 13.0 |
 *--------------+-----------+----------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
